import React from "react";
import { useToastState, useToastUpdater } from "../../../context/toastContext/toastContext";
import Toast from "../Toast";

const ToastWrapper = () => {
    const toast = useToastState();
    const { removeToast } = useToastUpdater();

    return (
        <div className="w-[25rem] fixed bottom-0 right-0 p-1 space-y-1 z-[10000]">
            {toast.map((toastItem) => (
                <Toast
                    id={toastItem.id}
                    key={toastItem.id}
                    title={toastItem.title}
                    status={toastItem.status}
                    href={toastItem.href}
                    removeToast={removeToast}
                />
            ))}
        </div>
    );
};

export default ToastWrapper;
